import React from 'react';
import { Icon } from '@unite-us/ui';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { isEmpty } from 'lodash';
import { dollarAmount } from 'src/common/display/Money/DollarAmount';

const InvoiceBulkActionsModalRows = ({
  invoices,
  deselectRows,
  erroredInvoiceIds,
}) => (
  <>
    <div className="my-6">
      {!isEmpty(invoices) &&
            invoices.map((invoice, index) => (
              <div
                id={`bulk-actions-form-row-${index + 1}`}
                key={`bulk-action-for-${invoice.short_id}`}
              >
                <div className="grid grid-cols-6 pl-5 mt-3">
                  <Link
                    to={`/invoices/${invoice.id}`}
                    className="item-center underline"
                  >
                    {invoice.short_id}
                  </Link>
                  <div className="flex justify-start mr-3">
                    <p className="truncate">
                      {invoice.fee_schedule_program_name}
                    </p>
                  </div>
                  <div className="flex justify-start">
                    <p className="truncate">{invoice.provider_name}</p>
                  </div>
                  <div className="flex justify-start inline-block pl-0">
                    <p className="truncate">{invoice.client_name}</p>
                  </div>
                  <div className="flex justify-end inline-block pl-0">
                    <strong>{dollarAmount(invoice.total_amount_invoiced, true)}</strong>
                  </div>
                  <div className="flex items-center justify-end">
                    <Icon
                      icon="IconCross"
                      size={10}
                      onClick={() => deselectRows(invoice)}
                    />
                    <div className="w-5 flex justify-center ml-1">
                      {erroredInvoiceIds?.has(invoice.id) && (
                        <div data-testid={`bulk-action-error-icon-${invoice.id}`}>
                          <Icon
                            className="fill-current text-red"
                            icon="IconExclamationCircle"
                            size={16}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
    </div>
  </>
  );

  InvoiceBulkActionsModalRows.propTypes = {
    invoices: PropTypes.array.isRequired,
    deselectRows: PropTypes.func.isRequired,
    erroredInvoiceIds: PropTypes.instanceOf(Set),
};

export { InvoiceBulkActionsModalRows };
